import { css, cx } from "styled-system/css";
import type { ReactNode } from "react";

interface CardProps {
  children: ReactNode;
  className?: string;
}

export function Card({ children, className }: CardProps) {
  return <div className={cx(styles.card, className)}>{children}</div>;
}

interface CardHeaderProps {
  children: ReactNode;
  className?: string;
}

export function CardHeader({ children, className }: CardHeaderProps) {
  return <div className={cx(styles.header, className)}>{children}</div>;
}

interface CardTitleProps {
  children: ReactNode;
  className?: string;
}

export function CardTitle({ children, className }: CardTitleProps) {
  return <h3 className={cx(styles.title, className)}>{children}</h3>;
}

interface CardDescriptionProps {
  children: ReactNode;
  className?: string;
}

export function CardDescription({ children, className }: CardDescriptionProps) {
  return <p className={cx(styles.description, className)}>{children}</p>;
}

interface CardContentProps {
  children: ReactNode;
  className?: string;
}

export function CardContent({ children, className }: CardContentProps) {
  return <div className={cx(styles.content, className)}>{children}</div>;
}

const styles = {
  // Editorial section, not a floating card: an ink rule on top, hairline
  // box, square corners, no shadow. Titles are sans small caps like a
  // newspaper section label.
  card: css({
    bg: "bg.default",
    borderRadius: "0",
    border: "1px solid",
    borderColor: "border.default",
    borderTopWidth: "2px",
    borderTopStyle: "solid",
    borderTopColor: "fg.default",
  }),
  header: css({
    px: 5,
    pt: 3,
    pb: 3,
    borderBottomWidth: "1px",
    borderBottomStyle: "solid",
    borderColor: "border.subtle",
  }),
  title: css({
    fontSize: "12px",
    fontWeight: "700",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "fg.default",
  }),
  description: css({
    fontSize: "sm",
    color: "fg.muted",
    mt: 1,
  }),
  content: css({
    p: 5,
  }),
};
